export default __webpack_public_path__ + "static/media/30t.2d09dcd7.jpg";